import { render, staticRenderFns } from "./modalGestaoUsuario.vue?vue&type=template&id=587febf6"
import script from "./modalGestaoUsuario.vue?vue&type=script&lang=js"
export * from "./modalGestaoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports